// extracted by mini-css-extract-plugin
export default {"eyeball":"style_eyeball__VfS7v","pupil":"style_pupil__z0wnJ","eyeballMove":"style_eyeballMove__98GXj"};